"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketSegment = exports.AccountType = exports.AccountStatus = exports.Product = void 0;
var Product;
(function (Product) {
    Product["INTEGRATE"] = "INTEGRATE";
    Product["LTI"] = "LTI";
    Product["LIBRARY"] = "LIBRARY";
    Product["CLASSROOM"] = "CLASSROOM";
})(Product || (exports.Product = Product = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["EXPIRED"] = "EXPIRED";
    AccountStatus["ARCHIVED"] = "ARCHIVED";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var AccountType;
(function (AccountType) {
    AccountType["DEMO"] = "DEMO";
    AccountType["TRIAL"] = "TRIAL";
    AccountType["STANDARD"] = "STANDARD";
})(AccountType || (exports.AccountType = AccountType = {}));
var MarketSegment;
(function (MarketSegment) {
    MarketSegment["HIGHER_EDUCATION"] = "HIGHER_EDUCATION";
    MarketSegment["K12"] = "K12";
})(MarketSegment || (exports.MarketSegment = MarketSegment = {}));
//# sourceMappingURL=Account.js.map